module.exports = __webpack_public_path__ + "media/images/size-guide-img4-de41cf02cee84f1598b027040e6c5b8f.png";